if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach((item) => {
        const remove = item.querySelector('.remove');
        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener(
            'input',
            debounce((e) => {
              e.preventDefault();
              e.target.blur();
              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener('click', (e) => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add('processing');
      if (typeof window.__cgtBusy === 'function') window.__cgtBusy(true);
      if (typeof window._disableCheckout === 'function') window._disableCheckout();
      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      // Address the line by its key, never by its index. Gift lines are added
      // and removed asynchronously by the tier sync, so a rendered data-line
      // index can point at a different item by the time the customer clicks
      // +/-, which silently changed the wrong row.
      const lineKey = item.dataset.id;
      const body = JSON.stringify(
        lineKey
          ? { id: lineKey, quantity: newQty }
          : { line: parseInt(item.dataset.line), quantity: newQty }
      );

      window.__cgtInternalWrite = true;
      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body,
      })
        .finally(() => {
          window.__cgtInternalWrite = false;
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML =
              typeof response.description === 'string' ? response.description : response.message;
            return null;
          }

          const items = response.items || [];
          if (items.length > 0) {
            const nonGiftItems = items.filter(
              (i) => !(i.properties && i.properties._is_gift === 'true')
            );
            // Nothing but gifts left — empty the cart rather than leaving the
            // customer with a cart of freebies they never qualified for.
            if (nonGiftItems.length === 0) {
              const updates = {};
              items.forEach((i) => {
                updates[i.key] = 0;
              });
              window.__cgtInternalWrite = true;
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates }),
              })
                .then((r) => r.json())
                .finally(() => {
                  window.__cgtInternalWrite = false;
                });
            }
          }

          // Hand the fresh cart to the tier sync as a seed so it does not have
          // to re-read what we already know.
          return response;
        })
        .then((seedCart) => {
          // Delegate the repaint. The tier sync reconciles gifts first and
          // paints ONCE at the end, so the customer never sees the in-between
          // state where the total has dropped but the gift is still listed.
          const tiersEl = document.querySelector('cart-gift-tiers');
          if (tiersEl && typeof tiersEl.syncGifts === 'function') {
            return tiersEl.syncGifts(seedCart, { forcePaint: true });
          }
          if (typeof window.__cgtRefreshCartHTML === 'function') {
            return window.__cgtRefreshCartHTML();
          }
          return this._legacyRefresh();
        })
        .then(() => {
          if (alert !== null) {
            const form = this.querySelector('form');
            if (form) form.prepend(alert);
          }
          this.dispatchEvent(new Event('cart-updated'));
        })
        .catch((e) => {
          console.warn('[cart] qty update failed', e);
          const err = document.createElement('span');
          err.classList.add('alert', 'alert--error');
          err.textContent = KROWN.settings.locales.cart_general_error;
          const form = this.querySelector('form');
          if (form) form.prepend(err);
        })
        .finally(() => {
          const form = this.querySelector('form');
          if (form) form.classList.remove('processing');
          if (typeof window.__cgtBusy === 'function') window.__cgtBusy(false);
          if (typeof window._enableCheckout === 'function') window._enableCheckout();
        });
    }

    // Fallback repaint for when the gift-tiers script is not on the page
    // (tiers disabled in theme settings).
    _legacyRefresh() {
      return fetch('?section_id=helper-cart')
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const formHtml = doc.getElementById('AjaxCartForm');
          const subtotalHtml = doc.getElementById('AjaxCartSubtotal');

          if (formHtml) {
            this.innerHTML = formHtml.innerHTML;
            this.ajaxifyCartItems();
          }
          const subtotal = document.getElementById('AjaxCartSubtotal');
          if (subtotal && subtotalHtml) subtotal.innerHTML = subtotalHtml.innerHTML;

          document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
            const src = this.querySelector('[data-cart-count]');
            if (src) elm.textContent = src.textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
            const src = this.querySelector('[data-cart-total]');
            if (src) elm.textContent = src.textContent;
          });
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById('AjaxCartForm')
          .updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
      }, 50);
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if (document.querySelector('cart-recommendations')) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }
      });
  };
}